import { getCurrentTime } from "@shared/utils/CommonUtils";
import { global } from "@shared/libs/Global";

const normalizeIssueDate = (value: any) => {
  if (value === null || value === undefined) return value;

  const text = String(value).trim();
  if (!text) return text;

  const digits = text.replace(/\D/g, "");
  if (digits.length === 8) return digits;

  return text;
};

export const getProgress = (formData: any) => {
  const js_progress = [
    {
      dt_due: normalizeIssueDate(formData.dt_due),
      cd_emp_admin: formData.cd_emp_admin,
      tm_start: formData.tm_start,
      cd_emp_start: formData.cd_emp_start,
      tm_finish: formData.tm_finish,
      cd_emp_finish: formData.cd_emp_finish,
      tm_cancel: formData.tm_cancel,
      cd_emp_cancel: formData.cd_emp_cancel,
      tm_reject: formData.tm_reject,
      cd_emp_reject: formData.cd_emp_reject,
      tm_assign: formData.tm_assign,
      tm_confirm: formData.tm_confirm,
      tm_close: formData.tm_close,
      tm_test: formData.tm_test,
    },
  ];

  let isEmpty: boolean = true;
  if (
    js_progress &&
    js_progress.length > 0 &&
    Object.keys(js_progress[0]).length > 0
  )
    isEmpty = false;
  return isEmpty ? undefined : js_progress;
};

export const getEtcInfo = (formData: any) => {
  const js_etc_info = [
    {
      cd_cust: formData.cd_cust,
      tp_issue1: formData.tp_issue1,
      tp_issue2: formData.tp_issue2,
      fg_priority: formData.fg_priority,
      cd_menu: formData.cd_menu,
      fg_schedule: formData.fg_schedule,
      cd_pjt: formData.cd_pjt,
      qt_md: formData.qt_md,
      qt_md_done: formData.qt_md_done,
    },
  ];

  let isEmpty: boolean = true;
  if (
    js_etc_info &&
    js_etc_info.length > 0 &&
    Object.keys(js_etc_info[0]).length > 0
  )
    isEmpty = false;
  return isEmpty ? undefined : js_etc_info;
};

export const getTxtBody = (body: any) => {
  const js_txt_body = [
    {
      txt_body: body || "",
    },
  ];

  let isEmpty: boolean = true;
  if (
    js_txt_body &&
    js_txt_body.length > 0 &&
    Object.keys(js_txt_body[0]).length > 0
  )
    isEmpty = false;
  return isEmpty ? undefined : js_txt_body;
};

export const getReply = (formData: any, replyList: any[], body: any) => {
  let no_line;
  if (replyList && replyList.length > 0) {
    no_line = replyList.length + 1;
  } else {
    no_line = 0;
  }

  if (body && body !== "") {
    const reply = {
      no_line: no_line.toString(),
      txt_body: body,
      tm_reg: getCurrentTime(),
      cd_user_reg: global.getState().userInfo.cd_user,
      nm_emp: global.getState().userInfo.nm_user,
    };
    replyList.push(reply);
  }

  let isEmpty: boolean = true;
  if (replyList && replyList.length > 0 && Object.keys(replyList[0]).length > 0)
    isEmpty = false;
  return isEmpty ? undefined : replyList;
};

export const getRelIssue = (formData: any) => {
  const js_rel = [];
  const no_issue_rel = formData.no_issue_rel;
  if (no_issue_rel && no_issue_rel.length > 0) {
    const rel_arr = no_issue_rel.split(",");
    for (let i = 0; i < rel_arr.length; i++) {
      const map = {
        no_issue_rel: rel_arr[i].trim(),
      };
      js_rel.push(map);
    }
  }

  return js_rel;
};

export const getEmp = (formData: any) => {
  const js_emp = [];

  const dc_recipient = formData.dc_recipient;
  if (dc_recipient !== null && dc_recipient !== "") {
    const recipient_arr = dc_recipient.split(",");
    for (let i = 0; i < recipient_arr.length; i++) {
      const map = {
        cd_emp: recipient_arr[i].trim(),
        fg_emp: "1",
        no_line: i + 1,
        tm_open: getCurrentTime(),
      };
      js_emp.push(map);
    }
  }

  const dc_reference = formData.dc_reference;
  if (dc_reference && dc_reference.length > 0) {
    const reference_arr = dc_reference.split(",");
    for (let i = 0; i < reference_arr.length; i++) {
      const map = {
        cd_emp: reference_arr[i].trim(),
        fg_emp: "2",
        no_line: i + 1,
        tm_open: getCurrentTime(),
      };
      js_emp.push(map);
    }
  }

  return js_emp;
};

export const getTag = (formData: any) => {
  const js_tag = [{}];
  const dc_tag = formData.dc_tag;
  if (dc_tag && dc_tag.length > 0) {
    const tag_arr = dc_tag.split(",");
    for (let i = 0; i < tag_arr.length; i++) {
      const map = {
        no_line: i + 1,
        dc_tag: tag_arr[i].trim(),
      };
      js_tag.push(map);
    }
  }

  return js_tag;
};

export const getScript = (
  scriptB: any,
  scriptP: any,
  scriptR: any,
  rowData1: any[],
  rowData2: any[],
  scriptList?: any[]
) => {
  const js_script: any[] = [];
  const currentTime = getCurrentTime();
  const currentUser = global.getState().userInfo.cd_user;

  const makeOneScript = (
    fg_script: "B" | "P" | "R",
    newScript: any,
    existingObj: any
  ) => {
    if (newScript === null || newScript === undefined) return;

    if (existingObj) {
      if (existingObj.txt_script !== newScript) {
        existingObj.txt_script = newScript;
        existingObj.tm_amd = currentTime;
        existingObj.cd_user_amd = currentUser;
      }
      js_script.push(existingObj);
    } else {
      if (newScript === "") return;
      js_script.push({
        fg_script,
        txt_script: newScript,
        tm_reg: currentTime,
        cd_user_reg: currentUser,
        yn_apply: "N",
      });
    }
  };

  const makeListScript = (script: string, rowData: any[], existingObj: any) => {
    if (!rowData || rowData.length === 0) return;

    if (existingObj) {
      existingObj.txt_script = rowData;
      existingObj.tm_amd = currentTime;
      existingObj.cd_user_amd = currentUser;
      js_script.push(existingObj);
    } else {
      js_script.push({
        fg_script: script,
        txt_script: rowData,
        tm_reg: currentTime,
        cd_user_reg: currentUser,
        yn_apply: "N",
      });
    }
  };

  if (scriptList && Array.isArray(scriptList)) {
    makeOneScript(
      "B",
      scriptB,
      scriptList.find((item) => item.fg_script === "B")
    );
    makeOneScript(
      "P",
      scriptP,
      scriptList.find((item) => item.fg_script === "P")
    );
    makeOneScript(
      "R",
      scriptR,
      scriptList.find((item) => item.fg_script === "R")
    );
    makeListScript(
      "S",
      rowData1,
      scriptList.find((item) => item.fg_script === "S")
    );
    makeListScript(
      "C",
      rowData2,
      scriptList.find((item) => item.fg_script === "C")
    );
  }

  return js_script;
};
